<template>
 <mt-actionsheet
      :actions="actions"
      :cancelText="$t('common.cancel')"
      v-model="sheetVisible"
    >
  </mt-actionsheet>

</template>
<script>
export default {
  data() {
    return {
        sheetVisible:false,
        actions:[]
    
    };
  },
  props: {
   
  },
  computed: {
   
  },
  methods: {
    changeLang({ value }) {
      localStorage.setItem("locale", value);
      this.lang = value;
      this.sheetVisible = false;
      setTimeout(() => {
        location.reload();
      }, 500);
    },
    selLanguage() {
      this.sheetVisible = true;
      const _this= this
      this.actions = [
        {
          name: "English",
          value: "en",
          method: (rea) => {
            _this.changeLang(rea);
          },
        },
        {
          name: "Español",
          value: "sp",
          method: (rea) => {
            _this.changeLang(rea);
          },
        },
        {
          name: "Français",
          value: "fr",
          method: (rea) => {
            _this.changeLang(rea);
          },
        },
        {
          name: "Deutsch",
          value: "de",
          method: (rea) => {
            _this.changeLang(rea);
          },
        },
        {
          name: "日本語",
          value: "jp",
          method: (rea) => {
            _this.changeLang(rea);
          },
        },
      ];
    },
   
  },
};
</script>
<style lang="less" scoped>

</style>